import {Command} from '@application/command/command';
import {CalendarItemGroup} from '@domain/planning/calendar-item-group';
import {PlanningItem} from '@domain/planning/planning-item';
import {moment} from '@vdw/angular-component-library';
import {each, remove} from 'lodash-es';
import {RemovePlanningItemsOutsideDateRangeParameters} from './remove-planning-items-outside-date-range-parameters';

export class RemovePlanningItemsOutsideDateRangeCommand implements Command<RemovePlanningItemsOutsideDateRangeParameters, void> {
  public execute(commandArgs: RemovePlanningItemsOutsideDateRangeParameters): void {
    const {groupedCalendarItems, dateRange} = commandArgs;

    each(groupedCalendarItems, (groupedCalendarItem: CalendarItemGroup) => {
      remove(groupedCalendarItem.items as PlanningItem[], (planningItem: PlanningItem) => {
        return !moment.range(planningItem.startDate, planningItem.endDate).overlaps(moment.range(...dateRange));
      });
    });
  }
}
